module.exports = __webpack_public_path__ + "img/vegetable-turnips-190x100.f3d53758.jpg";